import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router/index.js'
import { IS_DEV } from './config'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/globals.css'

Vue.use(BootstrapVue)

if (!IS_DEV && !window.location.href.match(/^https:/)) {
    window.location.href = window.location.href.replace(/^http:/, 'https:')
}

Vue.config.productionTip = false

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app')
